import React from "react";
import { useTranslation } from "react-i18next";

const Testimonials = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      stars: "★★★★★",
      quote: t("Before Hisabak I closed every night with paper. Now I close with one tap and I know my profit. Stock-outs dropped 40%."),
      initials: "AM",
      name: t("Ahmed Mostafa"),
      biz: t("Mostafa Mart · Cairo (3 branches)"),
    },
    {
      stars: "★★★★★",
      quote: t("Setup was honestly 8 minutes. The Arabic receipts and WhatsApp checkout convinced my older customers to come back."),
      initials: "RA",
      name: t("Reem Adel"),
      biz: t("Reem Pharmacy · Alexandria"),
    },
    {
      stars: "★★★★★",
      quote: t("We replaced an EGP 25,000 legacy system with Hisabak and got more features. Multi-branch reporting alone is worth it."),
      initials: "KS",
      name: t("Karim Saleh"),
      biz: t("Saleh Electronics · Mansoura"),
    },
  ];

  return (
    <section className="bg-gray-50 sm:py-20 " id="testimonials ">
      <div className="container mx-auto px-4">
        {/* Section Head */}
        <div className="mx-auto mb-14 max-w-3xl text-center">

          <h2 className="mb-4 text-2xl sm:text-4xl font-extrabold tracking-tight leading-tight text-gray-900">
            {t("Loved by 1,000+ store owners")}
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            {t("Real shops. Real numbers. Real growth - in their own words.")}
          </p>
        </div>

        {/* Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="rounded-2xl border border-gray-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              {/* Stars */}
              <div className="mb-4 text-[16px] text-amber-500">
                {item.stars}
              </div>
              {/* Quote */}
              <blockquote className="mb-5 text-[15px] leading-7 text-gray-700">
                "{item.quote}"
              </blockquote>
              {/* User */}
              <div className="flex items-center gap-3">
                {/* Avatar */}
                <div className="grid h-[42px] w-[42px] place-items-center rounded-full bg-gradient-to-r from-primaryBlue to-primaryBlue/80 text-sm font-bold text-white">
                  {item.initials}
                </div>
                {/* Info */}
                <div>
                  <div className="text-[14.5px] font-bold text-gray-900">
                    {item.name}
                  </div>
                  <div className="text-[13px] text-gray-500">
                    {item.biz}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;